export const CARD_COUNT = 24;
export const CARD_ASPECT = 51.1 / 68.14;
export const CARD_BORDER_RADIUS = 5.0;

export const GRID_X = [
  10, 19, 2, 13, 15, 9, 18, 22, 16, 12, 1, 17, 0, 3, 23, 14, 21, 11, 20, 8, 5,
  7, 6, 4,
];

export const GRID_Y = [
  6, 4, 5, 2, 3, 3, 2, 1, 7, 2, 3, 6, 0, 0, 4, 1, 1, 1, 4, 5, 2, 4, 0, 5,
];

export const IMAGES = [
  "/shared/images/img1.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img2.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img3.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img4.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img5.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img6.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img7.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img8.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img9.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img10.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img11.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img12.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img13.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img14.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img15.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img16.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img17.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img18.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img19.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img20.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img21.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img22.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img23.webp?auto=format&fit=crop&w=640&q=80",
  "/shared/images/img25.webp?auto=format&fit=crop&w=640&q=80",
];
